// extracted by mini-css-extract-plugin
export default {"layout":"styles_layout__QW1CL","layoutAuth":"styles_layoutAuth__gwfzz","main":"styles_main__D7urx","mainAuth":"styles_mainAuth__maboN"};